// extracted by mini-css-extract-plugin
module.exports = {"collection-container":"MyPurchases_collection-container__3DYT5","no-nfts":"MyPurchases_no-nfts__jhclu","input-container":"MyPurchases_input-container__1csZj"};